// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tag_tagContainer__GSKaT"};